module.exports = __webpack_public_path__ + "static/media/Foot Injury - Hexagon 1.59170f99.png";